<template>
  <NoteList :list="noteList" :is-loading="isLoading" :title="$t('text.haveDeadline')" is-officer />
</template>

<script>
import { mapGetters } from 'vuex';
import { NOTE_LIST_REQUEST } from '@/store/actions/note';
import NoteList from '@/components/note/NoteList';
import dataListMixin from '@/mixins/dataListMixin';
import moment from 'moment';

export default {
  mixins: [dataListMixin],

  props: {
    officer: Object,
  },

  components: { NoteList },

  data() {
    return {
      storeActionListRequest: NOTE_LIST_REQUEST,
      perPage: 100,
    };
  },

  computed: {
    ...mapGetters(['noteList', 'noteListStatus']),
    isLoading() {
      return this.noteListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[officerId]`] = this.officer.id;
      data.filters[`filter[reminderDate]`] = moment().format('YYYY-MM-DD');
    },
  },
};
</script>
